import React, { useState } from 'react';
import { Card, Switch, message, Typography, Spin } from 'antd';
import { useSettings } from '../../contexts/SettingsContext';
import { updateSettings as updateSettingsApi } from '../../services/settingsService';

const SiteSettings: React.FC = () => {
  const { ordersEnabled, loading, refresh } = useSettings();
  const [saving, setSaving] = useState(false);

  const handleOrdersEnabledChange = async (checked: boolean) => {
    setSaving(true);
    try {
      await updateSettingsApi({ ordersEnabled: checked });
      await refresh();
      message.success(
        checked
          ? 'Les commandes sont maintenant disponibles sur le site.'
          : 'Les commandes sont maintenant désactivées sur le site.'
      );
    } catch {
      message.error('Erreur lors de la mise à jour du paramètre.');
    } finally {
      setSaving(false);
    }
  };

  if (loading) {
    return (
      <div style={{ display: 'flex', justifyContent: 'center', padding: 48 }}>
        <Spin size="large" />
      </div>
    );
  }

  return (
    <div>
      <Typography.Title level={4}>Paramètres du site</Typography.Title>
      <Card title="Commandes sur le site" style={{ maxWidth: 560 }}>
        <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', flexWrap: 'wrap', gap: 16 }}>
          <div>
            <Typography.Text strong>Commandes disponibles sur le site</Typography.Text>
            <br />
            <Typography.Text type="secondary">
              Quand désactivé, le bouton « Ajouter au panier » sera inactif pour les visiteurs et les commandes en ligne seront refusées.
            </Typography.Text>
          </div>
          <Switch
            checked={ordersEnabled}
            onChange={handleOrdersEnabledChange}
            disabled={saving}
            checkedChildren="Activé"
            unCheckedChildren="Désactivé"
          />
        </div>
      </Card>
    </div>
  );
};

export default SiteSettings;
